var es = require('./es')
var cookie = require('./cookie')

module.exports = utils;

function utils () {}

var
  ua = navigator.userAgent,
  isQB = /\bQQBrowser\b/i.test(ua),

  ext = window.external;

utils.isQB = isQB;

var parseUrlParams = utils.parseUrlParams = function (str) {
  str || (str = '');
  var vars = str.split("&");
  var json = {}, pair;

  for (var i = 0; i < vars.length; i++) {
    pair = vars[i].split('=');
    json[pair[0]] = decodeURIComponent(pair[1] || '');
  }
  return json
};

var getUrlParams = utils.getUrlParams = function (key) {
  var query = window.location.search.substring(1);
  var json = parseUrlParams(query);
  utils.getUrlParams = function (k) {
    return k ? json[k] : json;
  };
  return key ? json[key] : json;
};

var ls = function (k, v) {
  var isread = arguments.length === 1, _ls = window.localStorage;
  if (_ls) {
    return isread ? _ls.getItem(k) : _ls.setItem(k, v);
  }
  return isread ? cookie(k) : cookie(k, v, {expires: 365 * 3});
};

var createGuid = utils.createGuid = function () {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

utils.getGuid = (function () {
  var k = '_noqb_guid', guid = '';

  return function () {
    if (guid) return guid;

    if (isQB && ext && ext.getGuid && ext.getGuid()) {
      guid = ext.getGuid().replace(/-/g, '');
    } else {
      guid = ls(k);
      if (!guid) {
        guid = createGuid();
        ls(k, guid);
      }
    }
    return guid;
  }
})();

utils.imgsend = function (url, fn1, fn2) {
  var img = new Image();
  img.onload = function(){ es.isFunction(fn1) && fn1() };
  img.onerror = function(){ es.isFunction(fn2) && fn2() };
  // img.src = url + '&t=' + (new Date()).getTime();
  img.src = url + '&r=' + Math.random();
  img = null;
};

// 等待 performance.timing.loadEventEnd 计算完成
// 如果浏览器不支持 performance.timing，则不执行
utils.onLoadEventEnd = (function () {
  var queue = [], timerHandler;

  function _wait() {
    clearTimeout(timerHandler);
    if (!performance.timing.loadEventEnd) {
      timerHandler = setTimeout(function () { _wait() }, 300);
      return;
    }

    for (var i = 0; i < queue.length; i++) {
      queue[i]();
    }
    queue = null;
  }

  return (window.performance && performance.timing) ? function (fn) {
    if (performance.timing.loadEventEnd) {
      fn();
    } else {
      queue.push(fn);
      _wait();
    }
  } : function (fn) {}
})();


//////////////////
// WEBPACK FOOTER
// ./src/helper/utils.js
// module id = 5
// module chunks = 0